import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logo from '../../assets/aba/logo-aba.png'
import logoPais from '../../assets/logos/pais.png'
import logoAtonito from '../../assets/logos/atonito.png'
import logoPeregrino from '../../assets/logos/peregrino.png'
import { Link } from 'react-router-dom';
import  Button from 'react-bootstrap/Button';
import '../ProductFamily/ProductFamily.css'
import { useTranslation } from 'react-i18next';

const styleFamilyProducts = {
    fontSize: '20px',
    textAlign: 'center',
    marginTop: '30px'
  };
const texts = {
  marginTop: '20px'
}

const texts1 = {
  marginTop: '50px',
  marginBottom: '30px'
}
const block1 = {
    backgroundColor: 'red',
    fontSize: '20px',
};
const block2 = {
    backgroundColor: 'yellow',
    fontSize: '20px',
};
const block3 = {
    backgroundColor: 'green',
    fontSize: '20px',
};
  

function ProductFamily() {
  
  const { i18n, t } = useTranslation()

  return (
    <Container style={styleFamilyProducts}>
      <Row>
        <Col><h2>{t('OurBrands')}</h2></Col>
      </Row>
      <Row>
        <hr/>
        <Col xs={12} md={3} style={{backgroundColor: '#2F4666', margin:'5px', borderRadius:'30px'}}>
          <Row style={texts1} >
            <Col xs={12}>
              <Link to='/peregrino'>
                <img
                  src={logoPeregrino}
                  width="90%"
                  height="100%"
                  className="d-inline-block align-top"
                  alt="Aba logo"
                />
              </Link>
            </Col>
          </Row>
        </Col>
        <Col md={1}></Col>
        <Col xs={12} md={3} style={{backgroundColor: '#27254A',  margin:'5px', borderRadius:'30px', marginTop:'2px'}}>
          <Row>
              <Col xs={12}>
                <Link to='/atonito'>
                  <img
                    src={logoAtonito}
                    width="90%"
                    height="100%"
                    className="d-inline-block align-top"
                    alt="Aba logo"
                    style={{ marginTop: '5px' }}
                  />
                </Link>
              </Col>
          </Row>
        </Col>
        <Col md={1}></Col>
        <Col xs={12} md={3} style={{backgroundColor: '#FCF0D6',  margin:'5px', borderRadius:'30px'}}>
          <Row>
              <Col style={texts} xs={12}>
                <Link to='/pais'>
                  <img
                      src={logoPais}
                      width="80px"
                      height="100%"
                      className="d-inline-block align-top"
                      alt="Aba logo"
                      style={{backgroundColor: '#FCF0D6', marginTop: '-5px'}}
                    />
                </Link>
              </Col>
            </Row>
        </Col>
      </Row>
      <hr/>
      <Row>
        <Col xs={12} md={12}>
              <Link to='/productFamily'><Button variant="primary">{t('btnViewProducts')}</Button></Link>
        </Col>
      </Row>
      {/* <Row>
        <Col xs={4} style={block1}>
          <Row>
              <Col style={block2} xs={12}>
                <img
                  src={logo}
                  width="100"
                  height="100"
                  className="d-inline-block align-top"
                  alt="Aba logo"
                />
              </Col>
              <Col style={block3} xs={12}>
                <span>Marca</span>
              </Col>
            </Row>
        </Col>
        <Col xs={4} style={block2}>
          <Row>
            <Col style={block2} xs={12}>
              <img
                src={logo}
                width="100"
                height="100"
                className="d-inline-block align-top"
                alt="Aba logo"
              />
            </Col>
            <Col style={block3} xs={12}>
              <span>Marca</span>
            </Col>
          </Row>
        </Col>
        <Col xs={4} style={block3}>
          <Row>
            <Col style={block2} xs={12}>
              <img
                src={logo}
                width="100"
                height="100"
                className="d-inline-block align-top"
                alt="Aba logo"
              />
            </Col>
            <Col style={block3} xs={12}>
              <span>Marca</span>
            </Col>
          </Row>
        </Col>
        <Col xs={4} style={block1}>
          <Row>
            <Col style={block2} xs={12}>
              <img
                src={logo}
                width="100"
                height="100"
                className="d-inline-block align-top"
                alt="Aba logo"
              />
            </Col>
            <Col style={block3} xs={12}>
              <span>Marca</span>
            </Col>
          </Row>
        </Col>
        <Col xs={4} style={block2}>
          <Row>
            <Col style={block2} xs={12}>
              <img
                src={logo}
                width="100"
                height="100"
                className="d-inline-block align-top"
                alt="Aba logo"
              />
            </Col>
            <Col style={block3} xs={12}>
              <span>Marca</span>
            </Col>
          </Row>
        </Col>
        <Col xs={4} style={block3}>
          <Row>
            <Col style={block2} xs={12}>
              <img
                src={logo}
                width="100"
                height="100"
                className="d-inline-block align-top"
                alt="Aba logo"
              />
            </Col>
            <Col style={block3} xs={12}>
              <span>Marca</span>
            </Col>
          </Row>
        </Col>
      </Row> */}
    </Container>
  );
}

export default ProductFamily;